import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Box, Stack } from '@mui/material';
import SuppliersTable from '../components/SuppliersTable';
import TopBar from '../../../components/TopBar';
import SupplierListPageActions from '../components/SupplierListPageActions';
import useSupplierFilters from '../components/SupplierFilterHelper';
import SupplierListFilters from '../components/SupplierListFilters';

function SupplierListPage() {

  const filters = [
    {
      type: 'search',
      options: [
        {
          key: 'name',
          placeholder: 'Supplier Name',
        },
        {
          key: 'company_id',
          placeholder: 'VAT Number',
        },
        {
          key: 'email',
          placeholder: 'Email',
        },
      ],
    },
  ];

  useDocumentTitle('Supplier List');

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  } = useSupplierFilters({ defaultQuery: {}, searchOnChange: true });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title={'Suppliers'}>
        <SupplierListPageActions />
      </TopBar>
      <Box mb={2}>
        <SupplierListFilters
          filters={filters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchKeyPress={handleSearchKeyPress}
          searchPlaceholder={'Search...'}
        />
      </Box>
      <SuppliersTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default SupplierListPage;
